import { render, staticRenderFns } from "./BannerImage.vue?vue&type=template&id=c31561b6&scoped=true&"
import script from "./BannerImage.vue?vue&type=script&lang=js&"
export * from "./BannerImage.vue?vue&type=script&lang=js&"
import style0 from "./BannerImage.vue?vue&type=style&index=0&id=c31561b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c31561b6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c31561b6')) {
      api.createRecord('c31561b6', component.options)
    } else {
      api.reload('c31561b6', component.options)
    }
    module.hot.accept("./BannerImage.vue?vue&type=template&id=c31561b6&scoped=true&", function () {
      api.rerender('c31561b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/progressbar/Stamp/components/BannerImage.vue"
export default component.exports